import { TEMPLATE_NAME_META_TAG } from 'constants/metadata';

export const AFTER_INTERACTIVE_STRATEGY = 'afterInteractive';
export const BEFORE_INTERACTIVE_STRATEGY = 'beforeInteractive';

export const APP_DYNAMICS_ID = 'App_Dynamics';
export const ADRUM_OPTANON_CATEGORY = 'C0002';
export const ADRUM_CLASS = 'optanon-category-C0002';

export const GOOGLE_TAG_MANAGER_ID = 'GTM-TBB6DV';
export const GOOGLE_TAG_MANAGER_TITLE = 'Google Tag Manager';
export const GOOGLE_TAG_MANAGER_SOURCE =
  'https://www.googletagmanager.com/ns.html?id=GTM-TBB6DV';
export const B2C_GA_ID = 'GA B2C';
export const DEFAULT_B2C_CLAIMS_DATA = {
  event: 'b2cloaded',
  companyID: null,
  HEM: null,
  loginID: null,
  catRecId: null,
  affClass: null,
  affCode: null,
  B2CdealerCode: null,
  topLvlOrgCode: null,
  B2CObjectID: null,
  B2CUserType: null,
  isCatCSR: 0,
  isCatCSRConnected: 0,
  isCatCSRConnectedGuest: 0
};
export const PAGE_LOAD_ID = 'GA page load';
export const PAGE_LOAD_SCRIPT = `(function(w,d,s,l,i){w[l]=w[l]||[];
  var gaPageLoadObj = {gaPageLoadObj};
  gaPageLoadObj.templateName = document.querySelector('meta[name="${TEMPLATE_NAME_META_TAG}"]').content || gaPageLoadObj.templateName;
  gaPageLoadObj.refApp = new URLSearchParams(document.location.search).get('refApp') || gaPageLoadObj.refApp;
  gaPageLoadObj.AAuserID = typeof window.AAuserID !== 'undefined' ? window.AAuserID : '';
  gaPageLoadObj.AAsession = typeof window.AAsession !== 'undefined' ? window.AAsession : '';
  gaPageLoadObj.lucid_fusion_query_id = sessionStorage.getItem('FUSION_QUERY_ID') ?? '';
  w[l].push(gaPageLoadObj);
})(window,document,'script','dataLayer','GTM-TBB6DV')`;

export const ADOBE_TARGET_SCRIPT = `
  var atDomain = "caterpillar.experiencecloud.adobe.com";
    var currentDomain = document.referrer;
	var antiClickjack = document.getElementById("antiClickjack");
	
	if (currentDomain.includes(atDomain)) {
		if(antiClickjack!=null){
            antiClickjack.parentNode.removeChild(antiClickjack);
        }
	} else if (self === top) {
		if(antiClickjack!=null){
            antiClickjack.parentNode.removeChild(antiClickjack);
        }
	} else{
          top.location = self.location;
    } `;
export const ADOBE_SCRIPT_ID = 'Adobe_Target';
